import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavbarMenu from "../../../../components/NavbarMenu";
import {
  getCarrito,
  updateItemNota,
  removeItem,
  clearCarrito,
  getSubtotal,
  getDomicilio,
  getTotal,
  getItemTotal,
} from "../hooks/carritoService";

/* ===============================
   ✅ DATOS DINÁMICOS DE PAGO (6am–1pm)
================================ */
const getDatosPagoPorHora = () => {
  const hora = new Date().getHours(); // 0-23 (hora local del dispositivo)
  const enRango = hora >= 6 && hora < 13; // 6:00 a 12:59

  const numero = enRango ? "3004719368" : "3017400249";

  return {
    nequi: numero,
    transferencia: `Llave: ${numero}`,
    notaCapture: "Por favor enviar el capture una vez hecho el pedido",
  };
};

export default function PedidoCarrito() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);

  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const [pagaCon, setPagaCon] = useState("");

  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);

  const recargar = () => {
    const carrito = getCarrito();
    setItems(carrito.items || []);
  };

  useEffect(() => {
    recargar();
  }, []);

  const actualizarNota = (item, nota) => {
    updateItemNota(item.lineId, nota);
    recargar();
  };

  const eliminar = (item) => {
    removeItem(item.lineId);
    recargar();
  };

  const editarProducto = (item) => {
    localStorage.setItem(
      "linea_editando",
      JSON.stringify({
        lineId: item.lineId,
      })
    );
    navigate(`/pedido/producto/${item.productId}`);
  };

  const subtotal = getSubtotal();
  const domicilio = getDomicilio();
  const total = getTotal();

  const abrirConfirmacion = () => {
    if (
      !nombre ||
      !telefono ||
      !direccion ||
      !metodoPago ||
      items.length === 0
    ) {
      alert("Completa todos los datos antes de continuar");
      return;
    }

    if (metodoPago === "Efectivo" && !pagaCon) {
      alert("Indica con cuánto cancela el cliente");
      return;
    }

    setMostrarConfirmacion(true);
  };

  const enviarWhatsApp = () => {
    const datosPago = getDatosPagoPorHora();

    let msg = "";
    msg += "*PEDIDO - DELIS TU MERIENDA*\n\n";

    msg += `*Cliente:* ${nombre} | Tel: ${telefono}\n`;
    msg += `*Dir:* ${direccion}\n`;
    msg += `*Pago:* ${metodoPago}`;

    if (metodoPago === "Efectivo") {
      msg += ` (paga con $${Number(pagaCon).toLocaleString("es-CO")})`;
    }

    if (metodoPago === "Nequi") {
      msg += `\nNequi: ${datosPago.nequi}`;
      msg += `\n${datosPago.notaCapture}`;
    } else if (metodoPago === "Transferencia") {
      msg += `\n${datosPago.transferencia}`;
      msg += `\n${datosPago.notaCapture}`;
    }

    msg += "\n\n*PRODUCTOS:*\n";

    items.forEach((p) => {
      let linea = `(${p.cantidad}) ${p.nombre}`;

      
      if (p.config?.base) {
        linea += ` (${p.config.base})`;
      }

      
      if (Array.isArray(p.config?.extras) && p.config.extras.length > 0) {
        linea +=
          " + " +
          p.config.extras
            .filter((e) => e.qty > 0)
            .map((e) => (e.qty > 1 ? `${e.name} x${e.qty}` : e.name))
            .join(" + ");
      }

      // Nota del producto (MUY IMPORTANTE)
      if (p.nota && p.nota.trim() !== "") {
        linea += ` | Nota: ${p.nota}`;
      }

      // Precio
      linea += `  $${getItemTotal(p).toLocaleString("es-CO")}\n`;

      msg += linea;
    });

    msg += `\n*Subtotal:* $${subtotal.toLocaleString("es-CO")}`;
    msg += `\n*Domicilio:* $${domicilio.toLocaleString("es-CO")}`;
    msg += `\n*TOTAL:* $${total.toLocaleString("es-CO")}`;

    const telefonoNegocio = "573017400249";

    window.open(
      `https://wa.me/${telefonoNegocio}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );

    clearCarrito();
    navigate("/pedido");
  };

  const datosPagoUI = getDatosPagoPorHora();
  const textoPagoUI =
    metodoPago === "Nequi"
      ? `Nequi: ${datosPagoUI.nequi}`
      : metodoPago === "Transferencia"
      ? datosPagoUI.transferencia
      : "";

  return (
    <section className="min-h-screen bg-black text-white">
      <NavbarMenu />

      <div className="pt-28 px-6 pb-28 max-w-4xl mx-auto space-y-8">
        <h1 className="text-3xl font-extrabold text-orange-400 text-center">
          Tu carrito
        </h1>

        {/* ITEMS */}
        <div className="bg-[#0f0f0f] rounded-xl border border-white/10 p-5 space-y-4">
          {items.length === 0 && (
            <p className="text-gray-400 text-center">Tu carrito está vacío</p>
          )}

          {items.map((p) => (
            <div key={p.lineId} className="space-y-2">
              <div className="flex justify-between items-start gap-3">
                <span className="text-sm">
                  {p.nombre}
                  {p.config?.base && ` (${p.config.base})`}
                  {p.config?.extras?.length > 0 &&
                    " + " +
                      p.config.extras
                        .map((e) => (e.qty > 1 ? `${e.name} x${e.qty}` : e.name))
                        .join(" + ")}
                  {" x" + p.cantidad} —{" "}
                  <span className="text-orange-400 font-semibold">
                    ${getItemTotal(p).toLocaleString("es-CO")}
                  </span>
                </span>

                <div className="flex gap-2">
                  <button
                    onClick={() => editarProducto(p)}
                    className="bg-yellow-500 text-black px-2 py-1 rounded text-xs font-bold"
                  >
                    Editar
                  </button>

                  <button
                    onClick={() => eliminar(p)}
                    className="text-red-400 text-lg"
                  >
                    ✕
                  </button>
                </div>
              </div>

              <input
                value={p.nota || ""}
                onChange={(e) => actualizarNota(p, e.target.value)}
                placeholder="Nota para este producto (opcional)"
                className="w-full bg-[#1a1a1a] p-2 rounded text-sm"
              />
            </div>
          ))}

          {items.length > 0 && (
            <>
              <p>Subtotal: ${subtotal.toLocaleString("es-CO")}</p>
              <p>Domicilio: ${domicilio.toLocaleString("es-CO")}</p>
              <p className="text-right font-bold text-lg">
                Total: ${total.toLocaleString("es-CO")}
              </p>
            </>
          )}
        </div>

        {/* DATOS CLIENTE */}
        {items.length > 0 && (
          <div className="space-y-4">
            <input
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Nombre del cliente"
              className="w-full p-3 rounded bg-[#1a1a1a]"
            />

            <input
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              placeholder="Teléfono"
              className="w-full p-3 rounded bg-[#1a1a1a]"
            />

            <input
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
              placeholder="Dirección de entrega"
              className="w-full p-3 rounded bg-[#1a1a1a]"
            />
            <p className="text-xs text-gray-400 mt-1">
              El valor del domicilio puede variar según distancia y horario.
              Te confirmaremos el costo final al confirmar el pedido.
            </p>
            <select
              value={metodoPago}
              onChange={(e) => {
                setMetodoPago(e.target.value);
                setPagaCon("");
              }}
              className="w-full p-3 rounded bg-[#1a1a1a]"
            >
              <option value="">Método de pago</option>
              <option value="Efectivo">Efectivo</option>
              <option value="Nequi">Nequi</option>
              <option value="Transferencia">Transferencia</option>
            </select>

            {/* ✅ Mostrar número/llave según hora cuando sea Nequi/Transferencia */}
            {(metodoPago === "Nequi" || metodoPago === "Transferencia") && (
              <div className="w-full p-3 rounded bg-[#121212] border border-white/10">
                <div className="text-sm text-green-400 font-semibold">
                  {textoPagoUI}
                </div>
                <div className="text-xs text-gray-300 mt-2">
                  {datosPagoUI.notaCapture}
                </div>
              </div>
            )}

            {metodoPago === "Efectivo" && (
              <input
                value={pagaCon}
                onChange={(e) => setPagaCon(e.target.value)}
                placeholder="Paga con cuánto"
                type="number"
                className="w-full p-3 rounded bg-[#1a1a1a]"
              />
            )}

            <button
              onClick={() => navigate("/pedido")}
              className="w-full bg-gray-700 py-3 rounded"
            >
              Seguir comprando
            </button>

            <button
              onClick={abrirConfirmacion}
              className="w-full bg-green-500 text-black py-4 rounded-xl font-extrabold"
            >
              Confirmar pedido
            </button>
          </div>
        )}
      </div>

      {/* CONFIRMACIÓN */}
      {mostrarConfirmacion && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-[#0f0f0f] p-6 rounded-xl max-w-md w-full space-y-4">
            <h2 className="text-xl font-bold text-orange-400">
              Confirmar pedido
            </h2>

            <p>Total a pagar: ${total.toLocaleString("es-CO")}</p>

            {/* ✅ Mostrar datos de pago también en confirmación */}
            {(metodoPago === "Nequi" || metodoPago === "Transferencia") && (
              <div className="p-3 rounded bg-[#121212] border border-white/10">
                <div className="text-sm text-green-400 font-semibold">
                  {textoPagoUI}
                </div>
                <div className="text-xs text-gray-300 mt-2">
                  {datosPagoUI.notaCapture}
                </div>
              </div>
            )}

            <div className="flex gap-3">
              <button
                onClick={() => setMostrarConfirmacion(false)}
                className="flex-1 bg-gray-600 py-2 rounded"
              >
                Cancelar
              </button>

              <button
                onClick={enviarWhatsApp}
                className="flex-1 bg-green-500 text-black py-2 rounded font-bold"
              >
                Enviar por WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
